import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { deleteAccountLink } from '../api'

interface UseDeleteAccountLinkParams {
  onSuccess?: (vars: DeleteAccountLinkVariables) => void
  onError?: (vars: DeleteAccountLinkVariables) => void
}

interface DeleteAccountLinkVariables {
  installationId: number
  accountId: number
}

type UseDeleteAccountLinkReturnType = (data: UseDeleteAccountLinkParams) => UseMutationResult<null, unknown, DeleteAccountLinkVariables>

/**
 * Hook to delete an account link for specific installation
 */
export const useDeleteAccountLink: UseDeleteAccountLinkReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation<null, unknown, DeleteAccountLinkVariables>({
    mutationFn: ({ installationId, accountId }) => deleteAccountLink(installationId, accountId, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })
}
